import Vue from 'vue'
import Router from 'vue-router'

import { hasPermission } from '@/permissions/auth.js'

import AgoraIndex from '@/components/Agora/Index.vue'
import P5Index from '@/components/P5/Index.vue'

import DoOmYogaHome from '@/components/doom_yoga/Home.vue'
import DoOmYogaLogin from '@/components/doom_yoga/auth/LoginView.vue'
import DoOmYogaForgetPassword from '@/components/doom_yoga/auth/ForgetPasswordView.vue'
import DoOmYogaResetPassword from '@/components/doom_yoga/auth/ResetPasswordView.vue'
import DoOmYogaRegister from '@/components/doom_yoga/auth/RegisterView.vue'
import DoOmYogaDashboard from '@/components/doom_yoga/Dashboard.vue'
import DoOmYogaCalendar from '@/components/doom_yoga/Calendar.vue'
import DoomYogaMyStudio from '@/components/doom_yoga/MyStudio.vue'
import DoomYogaMyEvents from '@/components/doom_yoga/events/List.vue'
import DoomYogaAddEvent from '@/components/doom_yoga/events/AddEvent.vue'
import DoomYogaEditEventClass from '@/components/doom_yoga/events/EditEventClass.vue'
import DoomYogaEditEventCourse from '@/components/doom_yoga/events/EditEventCourse.vue'
import DoomYogaEditEventPrivateClass from '@/components/doom_yoga/events/EditEventPrivateClass.vue'
import DoomYogaVideoLibrary from '@/components/doom_yoga/video_library/CategoryList.vue'
import DoomYogaVideoLibraryCategoryVideos from '@/components/doom_yoga/video_library/CategoryVideosList.vue'
import DoomYogaMusicLibrary from '@/components/doom_yoga/music_library/Index.vue'
import DoomYogaMusicLibrarySpotifyPlaylistTracks from '@/components/doom_yoga/music_library/SpotifyPlaylistTracks.vue'
import DoomYogaMusicLibraryMp3PlaylistTracks from '@/components/doom_yoga/music_library/Mp3PlaylistTracks.vue'
import DoomYogaMeditationLibrary from '@/components/doom_yoga/meditation_library/Index.vue'
import DoomYogaMeditationLibraryVideoCategoryTracks from '@/components/doom_yoga/meditation_library/VideoCategoryTracks.vue'
import DoomYogaMeditationLibraryAudioCategoryTracks from '@/components/doom_yoga/meditation_library/AudioCategoryTracks.vue'
import DoomYogaCustomersList from '@/components/doom_yoga/admin/customers/List.vue'
import DoomYogaMembershipsPacks from '@/components/doom_yoga/admin/memberships_packs/Index.vue'
import DoomYogaMarketing from '@/components/doom_yoga/admin/marketing/Index.vue'

// doom yoga customer
import DoOmYogaCustomerIndex from '@/components/doom_yoga/customer/Index.vue'
import DoOmYogaCustomerHome from '@/components/doom_yoga/customer/Home.vue'
import DoOmYogaCustomerEventsCalendar from '@/components/doom_yoga/customer/Events/Calendar.vue'
import DoOmYogaCustomerEventsBookSummary from '@/components/doom_yoga/customer/Events/BookSummary.vue'
import DoOmYogaCustomerEventsBookAsGuest from '@/components/doom_yoga/customer/Events/BookAsGuest.vue'
import DoOmYogaCustomerEventsBookPayment from '@/components/doom_yoga/customer/Events/Payment.vue'
import DoOmYogaCustomerMovement from '@/components/doom_yoga/customer/Movement/Index.vue'
import DoOmYogaCustomerMovementPlaylist from '@/components/doom_yoga/customer/Movement/VideosList.vue'
import DoOmYogaCustomerMeditation from '@/components/doom_yoga/customer/Meditation/Index.vue'
import DoOmYogaCustomerMeditationVideoPlaylist from '@/components/doom_yoga/customer/Meditation/VideosList.vue'
import DoOmYogaCustomerMeditationAudioPlaylist from '@/components/doom_yoga/customer/Meditation/AudiosList.vue'
import DoOmYogaCustomerMusic from '@/components/doom_yoga/customer/Music/Index.vue'
import DoOmYogaCustomerMusicMP3Playlist from '@/components/doom_yoga/customer/Music/AudiosList.vue'
import DoOmYogaCustomerMusicSpotifylaylist from '@/components/doom_yoga/customer/Music/SpotifyPlaylistTracks.vue'
import DoOmYogaCustomerProfileIndex from '@/components/doom_yoga/customer/Profile/Index.vue'
import DoOmYogaCustomerEditProfile from '@/components/doom_yoga/customer/Profile/EditProfile.vue'
import DoOmYogaCustomerProfileSubscription from '@/components/doom_yoga/customer/Profile/Subscription.vue'

// mid admin
import MIDLogin from '@/components/my_irish_date/auth/LoginView.vue'
import MIDForgetPassword from '@/components/my_irish_date/auth/ForgetPasswordView.vue'
import MIDResetPassword from '@/components/my_irish_date/auth/ResetPasswordView.vue'
import MIDDashboard from '@/components/my_irish_date/Dashboard.vue'
import MIDUsersList from '@/components/my_irish_date/users/List.vue'
import MIDEventsList from '@/components/my_irish_date/events/List.vue'
import MIDCalendar from '@/components/my_irish_date/Calendar.vue'
import MIDAddEvent from '@/components/my_irish_date/events/AddEvent.vue'
import MIDEditEvent from '@/components/my_irish_date/events/EditEvent.vue'
import MIDManageApp from '@/components/my_irish_date/ManageApp.vue'
import MIDManageGuidelines from '@/components/my_irish_date/manage_guidelines/Index.vue'
import MIDInterestsDescribeYourself from '@/components/my_irish_date/interests_describe/Index.vue'
import MIDQuestionnaires from '@/components/my_irish_date/Questionnaire.vue'
import MIDSplashScreens from '@/components/my_irish_date/SplashScreens.vue'
import MIDSettings from '@/components/my_irish_date/settings/Index.vue'
import MIDSpotifyPlaylists from '@/components/my_irish_date/music_library/SpotifyPlaylists.vue'
import MIDMusicLibrarySpotifyPlaylistTracks from '@/components/my_irish_date/music_library/SpotifyPlaylistTracks.vue'
import MIDVideoLibrary from '@/components/my_irish_date/video_library/CategoryList.vue'
import MIDVideoLibraryCategoryVideos from '@/components/my_irish_date/video_library/CategoryTracksList.vue'


// doorder admin 
import DoorderLogin from '@/components/doorder/auth/LoginView.vue'
import DoorderForgetPassword from '@/components/doorder/auth/ForgetPasswordView.vue'
import DoorderResetPassword from '@/components/doorder/auth/ResetPasswordView.vue'

import DoorderDashboard from '@/components/doorder/Dashboard.vue'
import DoorderRetailersRequests from '@/components/doorder/retailers/RequestsList.vue'
import DoorderRetailersList from '@/components/doorder/retailers/CurrentList.vue'
import DoorderRetailerSingleRequest from '@/components/doorder/retailers/SingleRequest.vue'
import DoorderRetailerSingleView from '@/components/doorder/retailers/ViewRetailer.vue'
import DoorderRetailerEdit from '@/components/doorder/retailers/EditRetailer.vue'

import DoOrderOrdersList from '@/components/doorder/orders/lists/ListIndex.vue'
import DoOrderOrdersHistoryList from '@/components/doorder/orders/lists/History.vue'
import DoorderViewOrder from '@/components/doorder/orders/ViewOrder.vue'

import DoorderRouteMap from '@/components/doorder/orders/route_optimization/RouteMap.vue'

// doorder retailer  
import DoOrderRetailerRegistration from '@/components/doorder/retailers/Registration/Index.vue'
import DoOrderAddOrder from '@/components/doorder/orders/AddOrder.vue'
import DoOrderAddMassOrder from '@/components/doorder/orders/AddMassOrder.vue'

// astrology 
import AstrologyLogin from '@/components/astrology_ventures/auth/LoginView.vue'
import AstrologyForgetPassword from '@/components/astrology_ventures/auth/ForgetPasswordView.vue'
import AstrologyResetPassword from '@/components/astrology_ventures/auth/ResetPasswordView.vue'
import AstrologyHome from '@/components/astrology_ventures/HomeAdmin.vue'
import AstrologyDashboard from '@/components/astrology_ventures/admin/Dashboard.vue'
import AstrologyObjectList from '@/components/astrology_ventures/admin/content_management/List'
import AstrologyObjectInfo from '@/components/astrology_ventures/admin/content_management/ObjectInfo'
import AstrologyMyStudio from '@/components/astrology_ventures/admin/MyStudio'
import AstrologyQuestionnaire from '@/components/astrology_ventures/admin/Questionnaire'

// astrology customer 
import AstrologyCustomerIndex from '@/components/astrology_ventures/customer/Index.vue'
import AstrologyCustomerHome from '@/components/astrology_ventures/customer/Home.vue'
import AstrologyCustomerCreateBirthChartIndex from '@/components/astrology_ventures/customer/birth_chart/Index.vue'

// garden help 
//auth
import GardenHelpLogin from '@/projects/garden_help/auth/LoginView.vue'
import GardenHelpForgetPassword from '@/projects/garden_help/auth/ForgetPasswordView.vue'
import GardenHelpResetPassword from '@/projects/garden_help/auth/ResetPasswordView.vue'
import GardenHelpResetPasswordCode from '@/projects/garden_help/auth/ResetPasswordCodeView.vue'
// contractor
import GardenHelpContractorRegister from '@/projects/garden_help/contractor/Register.vue'

import GardenHelpFindContractors from '@/projects/garden_help/contractor/FindContractors.vue'

import GardenHelpContractorProfile from '@/projects/garden_help/contractor/profiles_views/MyProfile.vue'
import GardenHelpPublicContractorProfile from '@/projects/garden_help/contractor/profiles_views/PublicProfile.vue'

import GardenHelpStaffList from '@/projects/garden_help/contractor/staff/List.vue'
import GardenHelpStaffViewProfile from '@/projects/garden_help/contractor/staff/ViewProfile.vue'

// Contractor Subscription
import GardenHelpContractorSubscription from '@/projects/garden_help/contractor/subscriptions.vue'

// job
import GardenHelpAddJob from '@/projects/garden_help/jobs/AddJob.vue'
import GardenHelpJobsBoard from '@/projects/garden_help/jobs/JobsBoard.vue'
import GardenHelpJobsDetails from '@/projects/garden_help/jobs/JobDetails.vue'
import GardenHelpMyJobs from '@/projects/garden_help/jobs/my_jobs/Index.vue'
import GardenHelpAllJobsAdmin from '@/projects/garden_help/jobs/my_jobs/IndexAdmin.vue'
import GardenHelpJobsTable from '@/projects/garden_help/jobs/jobs_table/Index.vue'
import GardenHelpEditJob from '@/projects/garden_help/jobs/EditJob.vue'

import GardenHelpAdminHome from '@/projects/garden_help/AdminHome.vue'
import GardenHelpContractorHome from '@/projects/garden_help/ContractorHome.vue'
import GardenHelpCustomerHome from '@/projects/garden_help/CustomerHome.vue'

import GardenHelpContractorSchedule from '@/projects/garden_help/jobs/Schedule.vue'

// quotes
import GardenHelpCreateQuoteIndex from '@/projects/garden_help/quotes/CreateQuoteIndex.vue'
import GardenHelpViewQuote from '@/projects/garden_help/quotes/ViewQuote.vue'
import GardenHelpViewQuotePublic from '@/projects/garden_help/quotes/ViewQuotePublic.vue'
import GardenHelpEditQuoteIndex from '@/projects/garden_help/quotes/EditQuoteIndex.vue'

// payment
import GardenHelpInvoicePayment from '@/projects/garden_help/payment/InvoicePayment.vue'
import GardenHelpSuccessPayment from '@/projects/garden_help/payment/SuccessPayment.vue'

// customer
import GardenHelpCustomerRegister from '@/projects/garden_help/customer/Register.vue'
import GardenHelpCustomerCurrentList from '@/projects/garden_help/customer/List/Current.vue'



Vue.use(Router)

import { i18n } from '../main'


const routes = [
   
    {
        path: '/agora_chat',
        name: 'AgoraIndex',
        component: AgoraIndex,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },
    {
        path: '/join_event/:booking_id/:event_name?',
        name: 'JoinEvent',
        component: AgoraIndex,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },
    {
        path: '/p5_test',
        name: 'P5Index',
        component: P5Index,
    },
    // doom yoga admin routes
    {
        path: '/doom_yoga/login/:type?',
        name: 'DoOmYogaLogin',
        component: DoOmYogaLogin,
        beforeEnter: (to, from, next) => checkIfAuthed(to, from, next)
    },
    {
        path: '/doom_yoga/sign_up',
        name: 'DoOmYogaRegister',
        component: DoOmYogaRegister,
        beforeEnter: (to, from, next) => checkIfAuthed(to, from, next)

    },
    {
        path: '/doom_yoga/forget_password',
        name: 'DoOmYogaForgetPassword',
        component: DoOmYogaForgetPassword
    },
    {
        path: '/doom_yoga/reset_password',
        name: 'DoOmYogaResetPassword',
        component: DoOmYogaResetPassword
    },
    {
        path: '/doom_yoga',
        name: 'DoOmYogaHome',
        component: DoOmYogaHome,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/doom_yoga/dashboard',
        name: 'DoOmYogaDashboard',
        component: DoOmYogaDashboard,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/doom_yoga/calendar',
        name: 'DoOmYogaCalendar',
        component: DoOmYogaCalendar,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/doom_yoga/my_studio',
        name: 'DoomYogaMyStudio',
        component: DoomYogaMyStudio,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/doom_yoga/my_events',
        name: 'DoomYogaMyEvents',
        component: DoomYogaMyEvents,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/doom_yoga/add_event',
        name: 'DoomYogaAddEvent',
        component: DoomYogaAddEvent,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/doom_yoga/edit_event/class/:id',
        name: 'DoomYogaEditEventClass',
        component: DoomYogaEditEventClass,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/doom_yoga/edit_event/course/:id',
        name: 'DoomYogaEditEventCourse',
        component: DoomYogaEditEventCourse,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/doom_yoga/edit_event/private_class/:id',
        name: 'DoomYogaEditEventPrivateClass',
        component: DoomYogaEditEventPrivateClass,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/doom_yoga/video_library',
        name: 'DoomYogaVideoLibrary',
        component: DoomYogaVideoLibrary,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/doom_yoga/video_library/category/:id',
        name: 'DoomYogaVideoLibraryCategoryVideos',
        component: DoomYogaVideoLibraryCategoryVideos,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/doom_yoga/music_library',
        name: 'DoomYogaMusicLibrary',
        component: DoomYogaMusicLibrary,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/doom_yoga/music_library/spotify_playlist/:id',
        name: 'DoomYogaMusicLibrarySpotifyPlaylistTracks',
        component: DoomYogaMusicLibrarySpotifyPlaylistTracks,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')

    },
    {
        path: '/doom_yoga/music_library/mp3_playlist/:id',
        name: 'DoomYogaMusicLibraryMp3PlaylistTracks',
        component: DoomYogaMusicLibraryMp3PlaylistTracks,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')

    },
    {
        path: '/doom_yoga/meditation_library',
        name: 'DoomYogaMeditationLibrary',
        component: DoomYogaMeditationLibrary,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/doom_yoga/meditation_library/video_category/:id',
        name: 'DoomYogaMeditationLibraryVideoCategoryTracks',
        component: DoomYogaMeditationLibraryVideoCategoryTracks,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')

    },
    {
        path: '/doom_yoga/meditation_library/audio_category/:id',
        name: 'DoomYogaMeditationLibraryAudioCategoryTracks',
        component: DoomYogaMeditationLibraryAudioCategoryTracks,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')

    },
    {
        path: '/doom_yoga/customers',
        name: 'DoomYogaCustomersList',
        component: DoomYogaCustomersList,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')

    },
    {
        path: '/doom_yoga/memberships_packs',
        name: 'DoomYogaMembershipsPacks',
        component: DoomYogaMembershipsPacks,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')

    },
    {
        path: '/doom_yoga/marketing',
        name: 'DoomYogaMarketing',
        component: DoomYogaMarketing,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')

    },
    // customer doomyoga routes

    {
        path: '/doom_yoga/index',
        name: 'DoOmYogaCustomerIndex',
        component: DoOmYogaCustomerIndex,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/doom_yoga/home',
        name: 'DoOmYogaCustomerHome',
        component: DoOmYogaCustomerHome,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },
    {
        path: '/doom_yoga/events',
        name: 'DoOmYogaCustomerEventsCalendar',
        component: DoOmYogaCustomerEventsCalendar,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },
    {
        path: '/doom_yoga/book_summary',
        name: 'DoOmYogaCustomerEventsBookSummary',
        component: DoOmYogaCustomerEventsBookSummary,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },
    {
        path: '/doom_yoga/book_as_guest',
        name: 'DoOmYogaCustomerEventsBookAsGuest',
        component: DoOmYogaCustomerEventsBookAsGuest,
        // beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },
    {
        path: '/doom_yoga/book_payment',
        name: 'DoOmYogaCustomerEventsBookPayment',
        component: DoOmYogaCustomerEventsBookPayment,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },

    {
        path: '/doom_yoga/movement',
        name: 'DoOmYogaCustomerMovement',
        component: DoOmYogaCustomerMovement,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },
    {
        path: '/doom_yoga/movement/playlist/:id',
        name: 'DoOmYogaCustomerMovementPlaylist',
        component: DoOmYogaCustomerMovementPlaylist,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },
    {
        path: '/doom_yoga/meditation',
        name: 'DoOmYogaCustomerMeditation',
        component: DoOmYogaCustomerMeditation,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },
    {
        path: '/doom_yoga/meditation_video/playlist/:id',
        name: 'DoOmYogaCustomerMeditationVideoPlaylist',
        component: DoOmYogaCustomerMeditationVideoPlaylist,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },
    {
        path: '/doom_yoga/meditation_audio/playlist/:id',
        name: 'DoOmYogaCustomerMeditationAudioPlaylist',
        component: DoOmYogaCustomerMeditationAudioPlaylist,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },
    {
        path: '/doom_yoga/music',
        name: 'DoOmYogaCustomerMusic',
        component: DoOmYogaCustomerMusic,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },
    {
        path: '/doom_yoga/music_mp3/playlist/:id',
        name: 'DoOmYogaCustomerMusicMP3Playlist',
        component: DoOmYogaCustomerMusicMP3Playlist,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },
    {
        path: '/doom_yoga/music_spotify/playlist/:id?',
        name: 'DoOmYogaCustomerMusicSpotifylaylist',
        component: DoOmYogaCustomerMusicSpotifylaylist, meta: {
            title: 'Spotify Authorization Code example page',
        },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },
    {
        path: '/doom_yoga/my_profile',
        name: 'DoOmYogaCustomerProfileIndex',
        component: DoOmYogaCustomerProfileIndex,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },
    {
        path: '/doom_yoga/my_profile/edit',
        name: 'DoOmYogaCustomerEditProfile',
        component: DoOmYogaCustomerEditProfile,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },
    {
        path: '/doom_yoga/my_profile/subscription',
        name: 'DoOmYogaCustomerProfileSubscription',
        component: DoOmYogaCustomerProfileSubscription,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },


    // mid admin routes
    {
        path: '/my_irish_date/login',
        name: 'MIDLogin',
        component: MIDLogin,
        beforeEnter: (to, from, next) => checkIfAuthed(to, from, next)
    },
    {
        path: '/my_irish_date/forget_password',
        name: 'MIDForgetPassword',
        component: MIDForgetPassword
    },
    {
        path: '/my_irish_date/reset_password',
        name: 'MIDResettPassword',
        component: MIDResetPassword
    },
    {
        path: '/my_irish_date/dashboard',
        name: 'MIDDashboard',
        component: MIDDashboard,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/my_irish_date/users',
        name: 'MIDUsersList',
        component: MIDUsersList,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/my_irish_date/events',
        name: 'MIDEventsList',
        component: MIDEventsList,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/my_irish_date/calendar',
        name: 'MIDCalendar',
        component: MIDCalendar,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/my_irish_date/add_event',
        name: 'MIDAddEvent',
        component: MIDAddEvent,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/my_irish_date/edit_event/:id',
        name: 'MIDEditEvent',
        component: MIDEditEvent,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/my_irish_date/manage_app',
        name: 'MIDManageApp',
        component: MIDManageApp,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/my_irish_date/manage_guidelines',
        name: 'MIDManageGuidelines',
        component: MIDManageGuidelines,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/my_irish_date/interests',
        name: 'MIDInterestsDescribeYourself',
        component: MIDInterestsDescribeYourself,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/my_irish_date/questionnaire',
        name: 'MIDQuestionnaires',
        component: MIDQuestionnaires,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/my_irish_date/splash_screens',
        name: 'MIDSplashScreens',
        component: MIDSplashScreens,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/my_irish_date/settings',
        name: 'MIDSettings',
        component: MIDSettings,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/my_irish_date/music_library/spotify_playlists',
        name: 'MIDSpotifyPlaylists',
        component: MIDSpotifyPlaylists,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/my_irish_date/music_library/spotify_playlist/:id',
        name: 'MIDMusicLibrarySpotifyPlaylistTracks',
        component: MIDMusicLibrarySpotifyPlaylistTracks,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)

    },

    {
        path: '/my_irish_date/video_library',
        name: 'MIDVideoLibrary',
        component: MIDVideoLibrary,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/my_irish_date/video_library/category/:id',
        name: 'MIDVideoLibraryCategoryVideos',
        component: MIDVideoLibraryCategoryVideos,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    // doorder routes

    {
        path: '/doorder/retailer/registraion',
        name: 'DoOrderRetailerRegistration',
        component: DoOrderRetailerRegistration,
        beforeEnter: (to, from, next) => checkIfAuthed(to, from, next)

    },
    {
        path: '/doorder/login/:type?',
        name: 'DoorderLogin',
        component: DoorderLogin,
        beforeEnter: (to, from, next) => checkIfAuthed(to, from, next)
    },
    {
        path: '/doorder/forget_password',
        name: 'DoorderForgetPassword',
        component: DoorderForgetPassword
    },
    {
        path: '/doorder/reset_password',
        name: 'DoorderResetPassword',
        component: DoorderResetPassword
    }, {
        path: '/doorder/dashboard',
        name: 'DoorderDashboard',
        component: DoorderDashboard,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    }, {
        path: '/doorder/retailer/requests',
        name: 'DoorderRetailersRequests',
        component: DoorderRetailersRequests,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    }, {
        path: '/doorder/retailers',
        name: 'DoorderRetailersList',
        component: DoorderRetailersList,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/doorder/retailer/requests/:id',
        name: 'DoorderRetailerSingleRequest',
        component: DoorderRetailerSingleRequest,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/doorder/retailers/view/:id',
        name: 'DoorderRetailerSingleView',
        component: DoorderRetailerSingleView,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/doorder/retailers/edit/:id',
        name: 'DoorderRetailerEdit',
        component: DoorderRetailerEdit,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/doorder/add_order',
        name: 'DoOrderAddOrder',
        component: DoOrderAddOrder,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/doorder/upload_orders',
        name: 'DoOrderAddMassOrder',
        component: DoOrderAddMassOrder,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/doorder/orders',
        name: 'DoOrderOrdersList',
        component: DoOrderOrdersList,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/doorder/orders/view/:id',
        name: 'DoorderViewOrder',
        component: DoorderViewOrder,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/doorder/orders_history',
        name: 'DoOrderOrdersHistoryList',
        component: DoOrderOrdersHistoryList,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/doorder/orders_history/view/:id',
        name: 'DoorderViewOrderHistory',
        component: DoorderViewOrder,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/doorder/orders/map_routes',
        name: 'DoorderRouteMap',
        component: DoorderRouteMap,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },


    //astrology admin routes
    {
        path: '/astrology_ventures/login/:type?',
        name: 'AstrologyLogin',
        component: AstrologyLogin,
        beforeEnter: (to, from, next) => checkIfAuthed(to, from, next)
    },
    {
        path: '/astrology_ventures/forget_password',
        name: 'AstrologyForgetPassword',
        component: AstrologyForgetPassword
    },
    {
        path: '/astrology_ventures/reset_password',
        name: 'AstrologyResetPassword',
        component: AstrologyResetPassword
    },
    {
        path: '/astrology_ventures',
        name: 'AstrologyHome',
        component: AstrologyHome,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/astrology_ventures/admin/dashboard',
        name: 'AstrologyDashboard',
        component: AstrologyDashboard,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/astrology_ventures/admin/content_management',
        name: 'AstrologyObjectList',
        component: AstrologyObjectList,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/astrology_ventures/admin/content_management/add_object',
        name: 'AstrologyObjectAdd',
        component: AstrologyObjectInfo,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/astrology_ventures/admin/content_management/object_info/:id',
        name: 'AstrologyObjectInfo',
        component: AstrologyObjectInfo,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/astrology_ventures/admin/my_studio',
        name: 'AstrologyMyStudio',
        component: AstrologyMyStudio,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/astrology_ventures/admin/my_studio/questionnaire',
        name: 'AstrologyQuestionnaire',
        component: AstrologyQuestionnaire,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },

    // customer doomyoga routes

    {
        path: '/astrology_ventures/index',
        name: 'AstrologyCustomerIndex',
        component: AstrologyCustomerIndex,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next)
    },
    {
        path: '/astrology_ventures/home',
        name: 'AstrologyCustomerHome',
        component: AstrologyCustomerHome,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },
    {
        path: '/astrology_ventures/create_birth_chart',
        name: 'AstrologyCustomerCreateBirthChartIndex',
        component: AstrologyCustomerCreateBirthChartIndex,
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'customer')
    },
    // garden help  routes
    {
        path: '/garden_help/login/:type?',
        name: 'GardenHelpLogin',
        component: GardenHelpLogin,
        meta: { title: 'GardenHelp' },
        beforeEnter: (to, from, next) => checkIfAuthed(to, from, next)
    },
    {
        path: '/garden_help/forget_password/:type',
        name: 'GardenHelpForgetPassword',
        meta: { title: 'GardenHelp' },
        component: GardenHelpForgetPassword
    },
    {
        path: '/garden_help/reset_password/:type',
        name: 'GardenHelpResetPassword',
        meta: { title: 'GardenHelp' },
        component: GardenHelpResetPassword
    },
    {
        path: '/garden_help/reset_password_code/:type',
        name: 'GardenHelpResetPasswordCode',
        meta: { title: 'GardenHelp' },
        component: GardenHelpResetPasswordCode
    },
    // contractor
    {
        path: '/garden_help/contractor/register',
        name: 'GardenHelpContractorRegister',
        component: GardenHelpContractorRegister,
        meta: { title: 'GardenHelp' },
        beforeEnter: (to, from, next) => checkIfAuthed(to, from, next)
    },
    {
        path: '/garden_help/find_contractors',
        name: 'GardenHelpFindContractors',
        component: GardenHelpFindContractors,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'user', auth_user: 'user' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'user')
    },
    {
        path: '/garden_help/my_profile',
        name: 'GardenHelpContractorProfile',
        component: GardenHelpContractorProfile,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'operator', auth_user: 'operator' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'operator')
    },
    {
        path: '/garden_help/subscription',
        name: 'GardenHelpContractorSubscription',
        component: GardenHelpContractorSubscription,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'operator', auth_user: 'operator' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'operator')
    },
    {
        path: '/garden_help/contractor_profile/:id',
        name: 'GardenHelpPublicContractorProfile',
        component: GardenHelpPublicContractorProfile,
        meta: { title: 'GardenHelp' },
        // beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'operator')
    },
    {
        path: '/garden_help/staff/list',
        name: 'GardenHelpStaffList',
        component: GardenHelpStaffList,
        meta: { title: 'GardenHelp', auth: 'operator', auth_user: 'company' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'operator')
    },

    {
        path: '/garden_help/staff/list/view/:id',
        name: 'GardenHelpStaffViewProfile',
        component: GardenHelpStaffViewProfile,
        meta: { title: 'GardenHelp', auth: 'operator', auth_user: 'company' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'operator')
    },

    // customer  
    {
        path: '/garden_help/customer/register',
        name: 'GardenHelpCustomerRegister',
        component: GardenHelpCustomerRegister,
        meta: { title: 'GardenHelp' },
        beforeEnter: (to, from, next) => checkIfAuthed(to, from, next)
    },
    {
        path: '/garden_help/customers/list',
        name: 'GardenHelpCustomerCurrentList',
        component: GardenHelpCustomerCurrentList,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'admin', auth_user: 'admin' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },

    // job 
    {
        path: '/garden_help/jobs/add_job/:contractor_id?',
        name: 'GardenHelpAddJob',
        component: GardenHelpAddJob,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'all', auth_user: 'company' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'all')
    },
    {
        path: '/garden_help/jobs/jobs_board',
        name: 'GardenHelpJobsBoard',
        component: GardenHelpJobsBoard,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'all', auth_user: 'company' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'all')
    },
    {
        path: '/garden_help/jobs/view_job/:id',
        name: 'GardenHelpJobsDetails',
        component: GardenHelpJobsDetails,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'all', auth_user: 'all' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'all')
    },
    {
        path: '/garden_help/jobs/view_job/:id/edit',
        name: 'GardenHelpJobsDetailsEdit',
        component: GardenHelpEditJob,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'all', auth_user: 'company' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'all')
    },
    {
        path: '/garden_help/jobs/my_jobs',
        name: 'GardenHelpMyJobs',
        component: GardenHelpMyJobs,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'operator', auth_user: 'operator' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'operator')
    },
    {
        path: '/garden_help/jobs/list_jobs',
        name: 'GardenHelpAllJobsAdmin',
        component: GardenHelpAllJobsAdmin,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'admin', auth_user: 'admin' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/garden_help/jobs/my_jobs/view_job/:status/:id',
        name: 'GardenHelpMyJobsJobDetails',
        component: GardenHelpJobsDetails,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'all', auth_user: 'all' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/garden_help/jobs/my_jobs/view_job/:status/:id/edit',
        name: 'GardenHelpMyJobsJobDetailsEdit',
        component: GardenHelpEditJob,
        meta: { title: 'GardenHelp', auth: 'all', auth_user: 'company' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    {
        path: '/garden_help/jobs/jobs_table',
        name: 'GardenHelpJobsTable',
        component: GardenHelpJobsTable,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'user', auth_user: 'user' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'user')
    },
    {
        path: '/garden_help/jobs/jobs_table/view_job/:status/:id',
        name: 'GardenHelpJobsTableJobDetails',
        component: GardenHelpJobsDetails,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'all', auth_user: 'all' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'all')
    },
    {
        path: '/garden_help/jobs/jobs_table/view_job/:status/:id/edit',
        name: 'GardenHelpJobsTableJobDetailsEdit',
        component: GardenHelpEditJob,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'all', auth_user: 'company' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'all')
    },
    {
        path: '/garden_help/jobs/schedule',
        name: 'GardenHelpContractorSchedule',
        component: GardenHelpContractorSchedule,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'operator', auth_user: 'operator' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'operator')
    },

    // quote
    {
        path: '/garden_help/send_quote/job/:id/:send_email?',
        name: 'GardenHelpCreateQuoteIndex',
        component: GardenHelpCreateQuoteIndex,
        meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'operator', auth_user: 'company' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'operator')
    },
    {
        path: '/garden_help/request_quote/:quote_id/job/:id/',
        name: 'GardenHelpRequestQuoteIndex',
        component: GardenHelpCreateQuoteIndex,
        meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'operator', auth_user: 'company' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'operator')
    },
    {
        path: '/garden_help/quote/view/:id',
        name: 'GardenHelpViewQuote',
        component: GardenHelpViewQuote,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'all', auth_user: 'company' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'all')
    },
    {
        path: '/garden_help/invoice/view/:code',
        name: 'GardenHelpViewQuotePublic',
        component: GardenHelpViewQuotePublic,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'all', auth_user: 'company' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'all')
    },
    {
        path: '/garden_help/quote/view/:id/edit',
        name: 'GardenHelpEditQuoteIndex',
        component: GardenHelpEditQuoteIndex,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'operator', auth_user: 'company' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'operator')
    },
    // payment 

    {
        path: '/garden_help/jobs/payment/:code',
        name: 'GardenHelpInvoicePayment',
        component: GardenHelpInvoicePayment,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'all', auth_user: 'company' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'all')
    },
    {
        path: '/garden_help/payment/success',
        name: 'GardenHelpSuccessPayment',
        component: GardenHelpSuccessPayment,
        // meta: { title: 'GardenHelp' },
        meta: { title: 'GardenHelp', auth: 'all', auth_user: 'company' },
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'all')
    },
    //home
    {
        path: '/garden_help',
        name: 'GardenHelpAdminHome',
        component: GardenHelpAdminHome,
        meta: { title: 'GardenHelp' },
        beforeEnter: (to, from, next) => checkIfAuthed(to, from, next)
        // beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    // contractor 
    {
        path: '/garden_help',
        name: 'GardenHelpContractorHome',
        component: GardenHelpContractorHome,
        meta: { title: 'GardenHelp' },
        beforeEnter: (to, from, next) => checkIfAuthed(to, from, next)
        // beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'admin')
    },
    // customer 
    {
        path: '/garden_help',
        name: 'GardenHelpCustomerHome',
        component: GardenHelpCustomerHome,
        meta: { title: 'GardenHelp' },
        // beforeEnter: (to, from, next) => checkIfAuthed(to, from, next)
        beforeEnter: (to, from, next) => redirectIfNotAuthed(to, from, next, 'user')
    },


]

const router = new Router({
    mode: 'history',
    routes,

    // scrollBehavior: function (to) {
    //     console.log(to)
    //     if (to.hash) {
    //         return {
    //             selector: to.hash
    //         }
    //     }
    // },

    // base: '/test_mid'
})
router.beforeEach(async (to, from, next) => {

    //Check if stripe onboard success
    if (to.query['stripe_onboard'] && to.query['stripe_onboard'] == 'success') {
        localStorage.removeItem('user')
        next({ name: 'GardenHelpLogin', params: { type: 'contractor' } })
    }
    // console.log('this.$route.query.test', this.$route.query.stripe_onboard);
    // console.log('this.$route.query.test', to.query['stripe_onboard']);
    // return;

    console.log("in router-beforeEach")
    // console.log(to)
    // console.log(from)
    // console.log(next)
    const title = to.meta.title
    if (title) {
        document.title = title
    }
    else {
        document.title = 'Bumblebee'
    }

    let auth = to.meta.auth, auth_user = to.meta.auth_user

    let user = localStorage.getItem('user');
    let user_type = localStorage.getItem('user_type');


    // console.log(auth, auth_user, to.meta.permission)
    // // console.log(user)
    // console.log(to.meta.title)
    // console.log(to.meta.permissions)

    if (auth && auth_user && to.meta.title == 'GardenHelp') {
        // console.log(auth, auth_user)
        // console.log(to.meta.permission)
        user = user ? JSON.parse(user) : {}
        // console.log(to.meta.title, user.type, user.is_company)
        // console.log(auth_user, user.is_company, user.is_staff)
        if (to.meta.title == 'GardenHelp' &&
            user.client == 'GARDENHELP' && user.type == 'operator') {
            if ((auth == 'all' && auth_user == 'all') ||
                (auth == 'operator' && auth_user == 'operator') ||
                ((auth == 'operator' || auth == 'all') && auth_user == 'company' && (user.is_company == 1 || (user.is_company == 0 && user.is_staff == 0)))
            ) {
                next()
            } else {
                next({ name: 'GardenHelpLogin', params: { type: 'contractor' } })
            }

            // if ((auth === user.type || auth=='all') && 
            //    ( (auth_user === 'company' || user.is_company == 1) || 
            //      ( auth_user == 'all' || (auth_user === 'operator' && user.is_company == 0 && user.is_staff == 0)
            //                         ))) {
            //     next()
            // } else {
            //     next({ name: 'GardenHelpLogin', params: { type: 'contractor' } })
            // }
        }
    }
   

    i18n.locale = localStorage.getItem('language') || 'en'
    return next()

    /** 
         * if (to.meta.requiresAuth) {
        const token = localStorage.getItem('token');
        if (token) {
        // User is authenticated, proceed to the route
        next();
        } else {
        // User is not authenticated, redirect to login
        next('/login');
        }
    } else {
        // Non-protected route, allow access
        next();
    } 
    */
})


function checkIfAuthed(to, from, next) {
    console.log("in check if authed")
    // console.log(localStorage)
    // console.log(to)
    // console.log(from)
    // console.log(next)
    let user = localStorage.getItem('user')
    let user_type = localStorage.getItem("user_type")
    // console.log(user)
    // console.log(user_type)
    // console.log("========================")
    if (user != null) {
        // console.log(user)
        // console.log(localStorage.getItem('customer'))
        if (to.path.includes('my_irish_date')) {
            next({ name: 'MIDDashboard' })
        } else if (to.path.includes('doorder')) {
            next({ name: 'DoOrderOrdersList' })
        } else if (to.path.includes('doom_yoga') && localStorage.getItem('customer') == null) {
            next({ name: 'DoOmYogaDashboard' })
        } else if (to.path.includes('doom_yoga') && localStorage.getItem('customer') == 'true') {
            next({ name: 'DoOmYogaCustomerHome' })
        } else if (to.path.includes('astrology') && localStorage.getItem('customer') == null) {
            next({ name: 'AstrologyDashboard' })
        } else if (to.path.includes('astrology') && localStorage.getItem('customer') == 'true') {
            next({ name: 'AstrologyCustomerHome' })
        } else if (to.path.includes('garden_help') && user_type == 'admin') {
            next({ name: 'GardenHelpAllJobsAdmin' })
        } else if (to.path.includes('garden_help') && user_type == 'operator') {
            next({ name: 'GardenHelpMyJobs' })
        } else if (to.path.includes('garden_help') && user_type == 'user') {
            next({ name: 'GardenHelpJobsTable' })
        } 

    } else {
        next();

    }
}

function redirectIfNotAuthed(to, from, next, user_type) {
    console.log("in redirect if not authed")
    // console.log(localStorage)
    let user = localStorage.getItem('user');
    let type = localStorage.getItem('user_type');
    // console.log(user)
    // console.log(type, user_type)
    // console.log("----------------------")
    // console.log(to)
    // console.log(from)
    // console.log(next)
    if (user === null) {
        if (to.path.includes('my_irish_date')) {
            next({ name: 'MIDLogin' })
        }
        // else if (to.path.includes('doorder') && user_type == 'admin') {
        //     next({ name: 'DoorderLogin', params: { type: 'admin' } })
        // }
        // else if (to.path.includes('doorder')) {
        //     next({ name: 'DoorderLogin' })
        // }
        else if (to.path.includes('doorder')) {
            if (type == 'admin') {
                next({ name: 'DoorderLogin', params: { type: 'admin' } })
            } else if (type == 'user' || type == 'retailer') {
                next({ name: 'DoorderLogin' })
            } else {
                next({ name: 'DoorderLogin' })
            }
        }

        else if (to.path.includes('doom_yoga') && user_type == 'admin') {
            next({ name: 'DoOmYogaLogin', params: { type: 'admin' } })
        } else if (to.path.includes('doom_yoga') && user_type == 'customer') {
            if (to.name == 'DoOmYogaCustomerHome' || to.name == 'DoOmYogaCustomerEventsCalendar' ||
                to.name == 'DoOmYogaCustomerEventsBookSummary' || to.name == 'DoOmYogaCustomerEventsBookPayment') {
                next();
            } else {
                next({ name: 'DoOmYogaLogin' })
            }
        }
        else if (to.path.includes('astrology') && user_type == 'admin') {
            next({ name: 'AstrologyLogin', params: { type: 'admin' } })
        } else if (to.path.includes('astrology') && user_type == 'customer') {
            if (to.name == 'AstrologyCustomerHome' || to.name == 'AstrologyCustomerCreateBirthChartIndex') {
                next();
            } else {
                next({ name: 'AstrologyLogin' })
            }
        }
        else if (to.path.includes('garden_help') &&
            (to.name == 'GardenHelpJobsBoard' || to.name == 'GardenHelpInvoicePayment'
                || to.name == 'GardenHelpSuccessPayment'
                || to.name == 'GardenHelpViewQuotePublic')) {
            next()
        }
        else if (to.path.includes('garden_help') && user_type == 'admin') {
            next({ name: 'GardenHelpLogin', params: { type: 'admin' } })
        }
        else if (to.path.includes('garden_help') && user_type == 'operator') {
            next({ name: 'GardenHelpLogin', params: { type: 'contractor' } })
        }
        else if (to.path.includes('garden_help') && user_type == 'user') {
            next({ name: 'GardenHelpLogin' })
        }
        else if (to.path.includes('garden_help') && user_type == 'all') {
            if (type == 'admin') {
                next({ name: 'GardenHelpLogin', params: { type: 'admin' } })
            }
            else if (type == 'operator') {
                next({ name: 'GardenHelpLogin', params: { type: 'contractor' } })
            }
            else {
                next({ name: 'GardenHelpLogin' })
            }
        }


        else if (to.path.includes('agora')) {
            next({ name: 'DoOmYogaLogin' })
        }
    } else {
        //Check if has Contractor has subscription 
        if (to.path.includes('garden_help')) {
            user = JSON.parse(user)
            if (user.has_subscription == false && to.path.includes('garden_help/my_profile') == false) {
                next({name: 'GardenHelpContractorProfile', query: {
                    setup: 'complete'
                }});
            }
        }
        next();
    }
}

// function checkIfProfileCompleted(to, from, next) {
//     let user = localStorage.getItem('user');
//     if (user === null) {
//         next({ name: 'DoOmYogaLogin' })
//     } else {
//         user = JSON.parse(user);
//         if (user.is_profile_completed === 0) {
//             next({ name: 'user-profile' })
//         } else {
//             next();
//         }
//     }
// }

export default router


// WEBPACK FOOTER //
// ./src/router/index.js